// =============================================================================
// JUST Button - Hide when Subscription is Selected
// =============================================================================

(function () {
  console.log("[JUST] Starting subscription detection...");

  // Configuration
  const DEBUG = true;

  function log(...args) {
    if (DEBUG) console.log("[JUST Subscription]", ...args);
  }

  // =============================================================================
  // PRODUCT PAGE: Hide JUST button when subscription is selected
  // =============================================================================

  function handleProductPageSubscription() {
    log("Setting up product page subscription detection...");

    let checkAttempts = 0;
    const maxAttempts = 50; // 25 seconds with 500ms intervals

    function checkSubscriptionWidget() {
      checkAttempts++;

      try {
        // Find the Recharge subscription widget
        const subscriptionWidget = document.querySelector(
          "recharge-subscription-widget"
        );
        const justButton = document.querySelector(
          'just-pay-button[source="product-form"], just-pay-button[source="customV2"]'
        );

        log(
          `Attempt ${checkAttempts}: Widget found: ${!!subscriptionWidget}, JUST button found: ${!!justButton}`
        );

        if (subscriptionWidget && justButton) {
          log(
            "Both subscription widget and JUST button found, setting up listeners..."
          );

          // Function to check current selection
          function checkCurrentSelection() {
            try {
              let isSubscriptionSelected = false;

              // Method 1: Check Recharge widget internal state via data attributes
              const widgetSelection =
                subscriptionWidget.getAttribute("data-selected-option") ||
                subscriptionWidget.getAttribute("data-current-selection");

              if (widgetSelection && widgetSelection.includes("subscription")) {
                isSubscriptionSelected = true;
                log(
                  "Subscription detected via widget attributes:",
                  widgetSelection
                );
              }

              // Method 2: Check for selling plan form inputs
              if (!isSubscriptionSelected) {
                const sellingPlanInputs = document.querySelectorAll(
                  'input[name*="selling_plan"]'
                );
                sellingPlanInputs.forEach((input) => {
                  if (
                    input.checked &&
                    input.value &&
                    input.value !== "" &&
                    input.value !== "null" &&
                    input.value !== "0"
                  ) {
                    isSubscriptionSelected = true;
                    log(
                      "Subscription detected via selling plan input:",
                      input.value
                    );
                  }
                });
              }

              // Method 3: Check for Recharge widget shadow DOM content (if accessible)
              if (!isSubscriptionSelected) {
                try {
                  const shadowRoot = subscriptionWidget.shadowRoot;
                  if (shadowRoot) {
                    const selectedSubscription =
                      shadowRoot.querySelector(
                        '.rc-option[data-selected="true"][data-option-type="subscription"]'
                      ) ||
                      shadowRoot.querySelector(
                        'input[type="radio"]:checked[value*="subscription"]'
                      ) ||
                      shadowRoot.querySelector(
                        '[data-testid="subscription-option"].selected'
                      );

                    if (selectedSubscription) {
                      isSubscriptionSelected = true;
                      log("Subscription detected via shadow DOM");
                    }
                  }
                } catch (shadowError) {
                  // Shadow DOM might not be accessible
                  log("Shadow DOM not accessible:", shadowError.message);
                }
              }

              // Method 4: Check for active subscription buttons/labels
              if (!isSubscriptionSelected) {
                const activeSubscriptionElements = document.querySelectorAll(
                  '.rc-option--selected[data-option-type="subscription"], ' +
                    '[data-testid="subscription-option"].active, ' +
                    '[data-testid="subscription-option"].selected, ' +
                    ".subscription-option.active, " +
                    ".subscription-selected, " +
                    'button[data-option="subscription"].selected, ' +
                    'button[data-option="subscription"].active'
                );

                if (activeSubscriptionElements.length > 0) {
                  isSubscriptionSelected = true;
                  log("Subscription detected via active elements");
                }
              }

              // Method 5: Check for French subscription text (specific to your site)
              if (!isSubscriptionSelected) {
                const subscriptionButtons = Array.from(
                  document.querySelectorAll("button, label, div")
                ).filter((el) => {
                  const text = el.textContent?.toLowerCase() || "";
                  return (
                    (text.includes("abonnement") ||
                      text.includes("s'abonner")) &&
                    (el.classList.contains("selected") ||
                      el.classList.contains("active") ||
                      el.getAttribute("aria-checked") === "true" ||
                      el.getAttribute("data-selected") === "true")
                  );
                });

                if (subscriptionButtons.length > 0) {
                  isSubscriptionSelected = true;
                  log("Subscription detected via French text buttons");
                }
              }

              // Method 6: Check global Recharge state (if available)
              if (!isSubscriptionSelected && window.Recharge) {
                try {
                  // Some Recharge implementations expose global state
                  if (
                    window.Recharge.currentSelection === "subscription" ||
                    window.Recharge.selectedOption === "subscription"
                  ) {
                    isSubscriptionSelected = true;
                    log("Subscription detected via global Recharge state");
                  }
                } catch (rechargeError) {
                  log(
                    "Error checking global Recharge state:",
                    rechargeError.message
                  );
                }
              }

              log("Final subscription status:", isSubscriptionSelected);

              // Hide/show JUST button accordingly
              if (isSubscriptionSelected) {
                justButton.style.display = "none";
                log("JUST button hidden due to subscription selection");
              } else {
                justButton.style.display = "";
                log("JUST button shown for one-time purchase");
              }
            } catch (error) {
              log("Error checking selection:", error);
            }
          }

          // Initial check
          checkCurrentSelection();

          // Set up mutation observer to watch for changes in the subscription widget
          const observer = new MutationObserver((mutations) => {
            let shouldCheck = false;
            mutations.forEach((mutation) => {
              if (
                mutation.type === "attributes" ||
                mutation.type === "childList"
              ) {
                shouldCheck = true;
              }
            });
            if (shouldCheck) {
              setTimeout(checkCurrentSelection, 100);
            }
          });

          // Observe the subscription widget and its shadow DOM if possible
          observer.observe(subscriptionWidget, {
            attributes: true,
            childList: true,
            subtree: true,
            attributeFilter: ["data-selected", "class", "aria-checked"],
          });

          // Also observe the document for form changes
          const formObserver = new MutationObserver(() => {
            checkCurrentSelection();
          });

          const productForm = document.querySelector(
            'form[action*="/cart/add"]'
          );
          if (productForm) {
            formObserver.observe(productForm, {
              attributes: true,
              childList: true,
              subtree: true,
            });
          }

          // Listen for change events on the document (for radio buttons, etc.)
          document.addEventListener("change", (e) => {
            if (
              e.target.name &&
              (e.target.name.includes("selling_plan") ||
                e.target.name.includes("subscription"))
            ) {
              log("Subscription form change detected");
              setTimeout(checkCurrentSelection, 100);
            }
          });

          // Listen for click events that might change subscription selection
          document.addEventListener("click", (e) => {
            if (
              e.target.closest("recharge-subscription-widget") ||
              e.target.closest(".subscription-option") ||
              e.target.closest('[data-testid*="subscription"]')
            ) {
              log("Subscription widget click detected");
              setTimeout(checkCurrentSelection, 200);
            }
          });

          log("Product page subscription monitoring set up successfully");
          return true; // Success
        }
      } catch (error) {
        log("Error in subscription widget check:", error);
      }

      return false; // Not ready yet
    }

    // Try immediately
    if (checkSubscriptionWidget()) {
      return;
    }

    // Keep trying until widget is ready
    const widgetInterval = setInterval(() => {
      if (checkSubscriptionWidget() || checkAttempts >= maxAttempts) {
        clearInterval(widgetInterval);
        if (checkAttempts >= maxAttempts) {
          log("Max attempts reached for product page setup");
        }
      }
    }, 500);
  }

  // =============================================================================
  // CART PAGE: Hide JUST button when cart contains subscription products
  // =============================================================================

  function handleCartPageSubscription() {
    log("Setting up cart page subscription detection...");

    async function checkCartForSubscriptions() {
      try {
        // Fetch current cart
        const response = await fetch("/cart.json");
        const cart = await response.json();

        log("Cart data:", cart);

        let hasSubscriptionItems = false;

        // Check each cart item for subscription properties
        for (const item of cart.items || []) {
          // Method 1: Check for selling plan (Recharge uses selling plans)
          if (
            item.selling_plan_allocation &&
            item.selling_plan_allocation.selling_plan
          ) {
            hasSubscriptionItems = true;
            log("Found subscription item via selling plan:", item.title);
            break;
          }

          // Method 2: Check item properties for subscription indicators
          if (item.properties) {
            const props = item.properties;
            if (
              props._subscription ||
              props.subscription ||
              props.recharge_subscription
            ) {
              hasSubscriptionItems = true;
              log("Found subscription item via properties:", item.title);
              break;
            }
          }

          // Method 3: Check for Recharge-specific line item properties
          if (
            item.variant_title &&
            item.variant_title.toLowerCase().includes("subscription")
          ) {
            hasSubscriptionItems = true;
            log("Found subscription item via variant title:", item.title);
            break;
          }
        }

        log("Cart has subscription items:", hasSubscriptionItems);

        // Find all JUST buttons on cart pages
        const cartJustButtons = document.querySelectorAll(
          'just-pay-button[source="cart"]'
        );

        cartJustButtons.forEach((button) => {
          if (hasSubscriptionItems) {
            button.style.display = "none";
            log("JUST button hidden due to subscription items in cart");
          } else {
            button.style.display = "";
            log("JUST button shown - no subscription items in cart");
          }
        });

        // Also check SuperCart if present
        const superCartJustButtons = document.querySelectorAll(
          ".super-cart-form just-pay-button, form.super-cart-form just-pay-button"
        );
        superCartJustButtons.forEach((button) => {
          if (hasSubscriptionItems) {
            button.style.display = "none";
            log("SuperCart JUST button hidden due to subscription items");
          } else {
            button.style.display = "";
            log("SuperCart JUST button shown - no subscription items");
          }
        });
      } catch (error) {
        log("Error checking cart for subscriptions:", error);
      }
    }

    // Check immediately
    checkCartForSubscriptions();

    // Set up cart monitoring
    let lastCartUpdate = Date.now();

    // Monitor cart changes via AJAX
    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
      const result = await originalFetch.apply(this, args);

      // Check if this is a cart-related request
      if (
        args[0] &&
        typeof args[0] === "string" &&
        (args[0].includes("/cart/add") ||
          args[0].includes("/cart/change") ||
          args[0].includes("/cart/update") ||
          args[0].includes("/cart/clear"))
      ) {
        log("Cart modification detected via fetch");
        setTimeout(checkCartForSubscriptions, 500);
      }

      return result;
    };

    // Listen for cart events
    document.addEventListener("cart:updated", () => {
      log("Cart updated event detected");
      setTimeout(checkCartForSubscriptions, 300);
    });

    document.addEventListener("cart:refresh", () => {
      log("Cart refresh event detected");
      setTimeout(checkCartForSubscriptions, 300);
    });

    // Periodic check as fallback
    setInterval(checkCartForSubscriptions, 5000);

    log("Cart page subscription monitoring set up successfully");
  }

  // =============================================================================
  // INITIALIZATION
  // =============================================================================

  function initialize() {
    log("Initializing subscription detection...");

    // Determine current page type
    const isProductPage =
      document.body.classList.contains("template-product") ||
      window.location.pathname.includes("/products/");

    const isCartPage =
      document.body.classList.contains("template-cart") ||
      window.location.pathname.includes("/cart");

    const isMiniCart =
      document.querySelector(".mini-cart") ||
      document.querySelector(".cart-drawer") ||
      document.querySelector(".super-cart-form");

    log("Page detection:", { isProductPage, isCartPage, isMiniCart });

    if (isProductPage) {
      handleProductPageSubscription();
    }

    if (isCartPage || isMiniCart) {
      handleCartPageSubscription();
    }

    // Also run for mini cart that might appear later
    if (!isCartPage) {
      setTimeout(() => {
        if (
          document.querySelector(".mini-cart, .cart-drawer, .super-cart-form")
        ) {
          log("Mini cart detected after delay, setting up cart monitoring...");
          handleCartPageSubscription();
        }
      }, 2000);
    }
  }

  // Run when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize);
  } else {
    initialize();
  }

  // Also run after a delay to catch late-loading elements
  setTimeout(initialize, 1000);
})();
